module.exports = __webpack_public_path__ + "static/sorrowful_6-4be16f8be024b72d9ca477af5a10d106.png";